import React from "react";
import clsx from "clsx";
import { Skeleton } from "@mui/material";
import "./CourseTrackingCardSkeleton.scss";

/**
 * Componente skeleton para CourseTrackingCard durante estados de carga
 * @param {Object} props - Propiedades del componente
 * @param {string} [props.className=""] - Clases CSS adicionales
 * @returns {JSX.Element} Componente skeleton de card de seguimiento de curso
 */
export const CourseTrackingCardSkeleton = ({ className = "", ...props }) => {
  return (
    <div
      className={clsx("course-tracking-card-skeleton", className)}
      {...props}
    >
      <div className="course-tracking-card-skeleton__image">
        <Skeleton variant="circular" width={48} height={48} animation="wave" />
      </div>

      <div className="course-tracking-card-skeleton__content">
        <div className="course-tracking-card-skeleton__title">
          <Skeleton variant="text" width="70%" height={20} animation="wave" />
        </div>

        <div className="course-tracking-card-skeleton__status">
          <Skeleton
            variant="circular"
            width={20}
            height={20}
            animation="wave"
          />
          <Skeleton variant="text" width="60%" height={16} animation="wave" />
        </div>
      </div>
    </div>
  );
};
